import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Users, FileText, Activity, Plus } from 'lucide-react';
import { facilitiesApi } from '../lib/api';
import { useAuthStore } from '../store/authStore';

export default function DashboardPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  const { data: stats, isLoading } = useQuery({
    queryKey: ['facility-stats'],
    queryFn: facilitiesApi.stats,
  });

  const statCards = [
    { label: 'Total Patients', value: stats?.totalPatients, icon: Users, color: 'text-blue-600 bg-blue-50' },
    { label: 'Consultations (30 days)', value: stats?.consultationsLast30Days, icon: Activity, color: 'text-green-600 bg-green-50' },
    { label: 'Finalised Notes', value: stats?.finalisedNotes, icon: FileText, color: 'text-purple-600 bg-purple-50' },
  ];

  return (
    <div className="p-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-semibold text-slate-800">
            Good {getGreeting()}, Dr. {user?.lastName}
          </h1>
          <p className="text-clinical-muted mt-1">Here's what's happening at {user?.facilityName || 'your facility'}.</p>
        </div>
        <button
          onClick={() => navigate('/app/consultations/new')}
          className="btn-primary"
        >
          <Plus className="w-4 h-4" />
          New Consultation
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-5 mb-8">
        {statCards.map(({ label, value, icon: Icon, color }) => (
          <div key={label} className="card p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-clinical-muted">{label}</p>
                <p className="text-3xl font-semibold text-slate-800 mt-1">
                  {isLoading ? '—' : (value ?? 0)}
                </p>
              </div>
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${color}`}>
                <Icon className="w-6 h-6" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <div className="card p-6">
        <h2 className="font-semibold text-slate-800 mb-4">Quick Actions</h2>
        <div className="flex gap-3">
          <button onClick={() => navigate('/app/consultations/new')} className="btn-primary">
            <Plus className="w-4 h-4" />
            Start Consultation
          </button>
          <button onClick={() => navigate('/app/patients')} className="btn-secondary">
            <Users className="w-4 h-4" />
            Find Patient
          </button>
        </div>
      </div>
    </div>
  );
}

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'morning';
  if (h < 17) return 'afternoon';
  return 'evening';
}
